import React from 'react';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { push } from 'redux-first-history';
import { compose, withHandlers } from 'recompose';
import { RouteComponentProps, withRouter } from 'react-router';

import { uiSelector } from '../store/selectors';
import { RootState } from '../store/reducers';
import { uiActions } from '../store/actions';
import { pushHistoryByUrl } from '../store/router/router.actions';

export interface WithNavigation<T = any> extends RouteComponentProps<T> {
  goBack: () => void;
  goTo: typeof pushHistoryByUrl;
}

function withNavigation<P extends object>(Comp: React.FunctionComponent<{ children?: React.ReactNode }>) {
  class WrappedComponent extends React.Component {
    public render() {
      return <Comp {...this.props} />;
    }
  }

  const mapStateToProps = (state: RootState, props): P => ({
    ...props,
    redirectPath: uiSelector.getRedirectPath(state),
    location: state.router.location.pathname,
  });

  const mapDispatchToPropsBefore = (dispatch: Dispatch) =>
    bindActionCreators(
      {
        goTo: push,
        resetRedirectPath: uiActions.resetRedirectPath,
      },
      dispatch,
    );

  const mapDispatchToProps = (dispatch: Dispatch) =>
    bindActionCreators(
      {
        goTo: push,
      },
      dispatch,
    );

  return compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToPropsBefore),
    withHandlers<WithNavigationProps, {}>({
      goToHandler: ({ goTo }) => (path: string) => () => {
        goTo(path);
      },
      goToWithGuard: (props: any) => (path?) => {
        props.goTo(props.redirectPath || path);
        if (props.redirectPath) {
          props.resetRedirectPath();
        }
      },
    }),
    connect(mapStateToProps, mapDispatchToProps),
  )(WrappedComponent);
}

export interface WithNavigationProps {
  goTo: typeof push;
  goToHandler: (path: string) => any;
  goToWithGuard: (path: string) => any;
}

export default withNavigation;
